import { useTheme } from 'contexts'
import Constants from 'expo-constants'
import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import * as Yup from 'yup'

import { MyFormValues } from 'partials/EditProfileForm'

import { Box } from 'widgets/Box'
import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'
import { Text } from 'widgets/Text'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { postFollow } from 'utils/queries/follows'
import { toSlug } from 'utils/string'

type UsernameFormProps = {
  initialValues: MyFormValues
  onSubmit: (values: any) => void
}

export const UsernameForm = ({ initialValues, onSubmit }: UsernameFormProps) => {
  const theme = useTheme()
  const { data: currentUser } = useCurrentUser()
  const computedStyles = StyleSheet.create({
    fieldStyles: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: theme.colors.greyLight,
      color: 'white',
    },
  })

  const autoFollowUserIds = useMemo(() => {
    const currentEnvironment = Constants?.manifest?.extra?.environment ?? 'development'

    // Shaun, Chris, Dom
    if (currentEnvironment === 'production') {
      return [
        'ENebHwOkoJbEl4Smz3qnj9O2KQv2',
        'dJDWYIo8xiSUcVdzB4IgsaK7Rcq1',
        'V5maOoqPV0Shys2ESSjDfw4P0HV2',
      ]
    }

    // upswingzac, shaunzieg9
    if (currentEnvironment === 'staging') {
      return ['js7dpdQUBMf4l8GqxYECfFbDMDY2']
    }

    // upswingzac, mak111
    return ['P9JH1nUxkJdavgx2vfwNkKs1JQY2', 'b2qNxn3iFfS9kEiLV438pSuEMbE2']
  }, [])

  const handleUsernameSubmit = (values: any) => {
    autoFollowUserIds.forEach(async (userId) => {
      try {
        await postFollow({
          follower: { id: currentUser?.id, username: values.username },
          trainer: { id: userId },
        })
        // eslint-disable-next-line no-empty
      } catch (e) {}
    })
    onSubmit(values)
  }

  return (
    <>
      <Box testID='FormTitle' margin={{ horizontal: 'md' }}>
        <Text color='white'>Pick a username</Text>
      </Box>
      <Box testID='UsernameForm' margin={{ top: 'sm' }}>
        <Form
          initialValues={initialValues}
          onSubmit={handleUsernameSubmit}
          submitCopy='NEXT'
          validationSchema={Yup.object().shape({
            username: Yup.string().required('This field is required.'),
          })}
        >
          {({ errors: formikErrors, touched }: any) => {
            return (
              <>
                <Field
                  required
                  icon='at-sign'
                  name='username'
                  placeholder='Username'
                  placeholderTextColor={theme.colors.greyDarker}
                  format={(value: string) => toSlug(value, { trim: false, strict: false })}
                  style={computedStyles.fieldStyles}
                />
              </>
            )
          }}
        </Form>
      </Box>
    </>
  )
}
